import constants from "@/config/default/constants";

export default {
  ...constants,
  APP_PREFIX_NAME: "PMTO",
  APP_NAME: ""
};
